import { Link } from 'react-router-dom';
import { removeBaseUrl } from '../../utils';

import './our_difference_section.scss';

export const OurDifferenceSection = ({
    fields
}) => {
    
    return <section id="our-difference-section" className="home-section">
        <div className="container">
            <div className="section-left-content">
                <div className='decoration'></div>
                <div className='content'>
                    <span className='main-category'>Our Difference</span>
                    <h2>
                        <span className='title-first'>{ fields?.od_title}</span>
                        <div><span className='title-second'>{ fields?.od_title_2}</span></div>
                    </h2>
                    <p className='description' dangerouslySetInnerHTML={{__html: fields?.od_description}}></p>
                    <a href={removeBaseUrl(fields?.od_button?.button_link)} className='button btn-white'>{ fields?.od_button?.button_label }</a>
                </div>
            </div>
            <div className="section-right-content">
            </div>
        </div>
    </section>
}